/* jshint esversion: 11 */

// Verschlüsselung lokal gespeicherter Geheimnisse (Tokens, Schlüssel des Krypto-Stores).
//
// Der AES-GCM-Schlüssel wird einmal pro Browser erzeugt und nicht exportierbar in
// IndexedDB abgelegt. Er lässt sich damit nur im Browser verwenden, nicht auslesen:
// Wer eine Kopie von localStorage erbeutet, hat nur Chiffrat. Gegen Code, der in der
// laufenden Seite ausgeführt wird, schützt das nicht.

const DB_NAME = "ziege-keys";
const STORE = "keys";
const KEY_ID = "pickle";

function openKeyDb() {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = () => request.result.createObjectStore(STORE);
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

function idbRequest(db, mode, action) {
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE, mode);
        const request = action(tx.objectStore(STORE));
        tx.oncomplete = () => resolve(request.result);
        tx.onerror = () => reject(tx.error);
    });
}

async function pickleKey({create}) {
    const db = await openKeyDb();
    try {
        let key = await idbRequest(db, "readonly", (store) => store.get(KEY_ID));
        if (!key && create) {
            key = await crypto.subtle.generateKey({name: "AES-GCM", length: 256}, false, ["encrypt", "decrypt"]);
            await idbRequest(db, "readwrite", (store) => store.put(key, KEY_ID));
        }
        return key ?? null;
    } finally {
        db.close();
    }
}

function toBase64(bytes) {
    return btoa(String.fromCharCode(...new Uint8Array(bytes)));
}

function fromBase64(b64) {
    return Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
}

export async function encryptJson(value) {
    const key = await pickleKey({create: true});
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const plaintext = new TextEncoder().encode(JSON.stringify(value));
    const ciphertext = await crypto.subtle.encrypt({name: "AES-GCM", iv}, key, plaintext);
    return {iv: toBase64(iv), data: toBase64(ciphertext)};
}

// Liefert null, wenn der Schlüssel fehlt oder nicht passt (z. B. nach Löschen der
// Website-Daten ohne localStorage).
export async function decryptJson({iv, data}) {
    const key = await pickleKey({create: false});
    if (!key) {
        return null;
    }
    try {
        const plaintext = await crypto.subtle.decrypt({name: "AES-GCM", iv: fromBase64(iv)}, key, fromBase64(data));
        return JSON.parse(new TextDecoder().decode(plaintext));
    } catch (e) {
        console.error("Gespeicherte Geheimnisse nicht entschlüsselbar: ", e);
        return null;
    }
}

export function randomStorageKey() {
    return toBase64(crypto.getRandomValues(new Uint8Array(32)));
}

export function storageKeyBytes(b64) {
    return fromBase64(b64);
}

export function deletePickleKey() {
    return new Promise((resolve) => {
        const request = indexedDB.deleteDatabase(DB_NAME);
        request.onsuccess = request.onerror = request.onblocked = () => resolve();
    });
}
